// src/components/sidebar/SidebarItems.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import { sideBarMenu } from "./utils/SidebarMenu";

type SideBarMenuItem = {
  title: string;
  icon: string;
  activeIcon: string;
  path: string;
  requiredPermission?: string;
};

interface SidebarItemsProps {
  /** Optional filtered list from parent. If omitted, uses the full sideBarMenu. */
  items?: SideBarMenuItem[];
  onDrawerClose?: () => void;
  isMobile?: boolean;
}

const SidebarItems: React.FC<SidebarItemsProps> = ({
  items,
  onDrawerClose,
  isMobile,
}) => {
  const navigate = useNavigate();

  // Use provided items (filtered) or fall back to the full menu
  const menu: SideBarMenuItem[] = items ?? sideBarMenu;

  return (
    <div className="w-full flex flex-col gap-[10px] justify-center items-center pt-4 pb-4">
      {menu.map((item) => (
        <SidebarItem
          key={item.title}
          icon={item.icon}
          activeIcon={item.activeIcon}
          title={item.title}
          path={item.path} // helps active highlighting
          onClick={() => {
            const path =
              typeof item.path === "string" && item.path.length > 0
                ? item.path
                : item.title === "Home"
                ? "/doctor"
                : `/${item.title.toLowerCase()}`;
            navigate(path);
            if (isMobile && onDrawerClose) onDrawerClose();
          }}
        />
      ))}
    </div>
  );
};

export default SidebarItems;
